import { REHYDRATE } from 'redux-persist';
import { LOGIN_INIT, LOGOUT } from 'actions/loginStateActions';
import {
  DEFECT_CATEGORY_LIST_FETCH_BEGIN,
  DEFECT_CATEGORY_LIST_FETCH_SUCCESS,
  DEFECT_CATEGORY_LIST_FETCH_FAIL,
} from './types';
import INITIAL_STATE from './state';

export default function defectCategoryListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case DEFECT_CATEGORY_LIST_FETCH_BEGIN:
      return { ...INITIAL_STATE, status: 'fetching' };

    case DEFECT_CATEGORY_LIST_FETCH_SUCCESS:
      return { data: action.data, status: 'idle' };

    case DEFECT_CATEGORY_LIST_FETCH_FAIL:
      return { ...INITIAL_STATE, status: 'failed', failReason: action.reason };

    case LOGIN_INIT:
    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}
